import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';

import { ProductStatus } from './plan-picker.types';

@Pipe({
  name: 'rtPlanPickerProductCtaLabel',
  pure: true,
  standalone: true,
})
export class PlanPickerProductCtaLabelPipe implements PipeTransform {
  constructor(private i18n: I18nService) {}

  public transform(value: ProductStatus, isAssigned?: boolean): any {
    // eslint-disable-next-line default-case
    switch (value) {
      case ProductStatus.Owned:
        return this.i18n.translate('app.pricing.plan_picker.your_current_plan');
      case ProductStatus.SelfService:
        return isAssigned
          ? this.i18n.translate('app.pricing.plan_picker.finish_your_order')
          : this.i18n.translate('app.pricing.plan_picker.choose_a_plan');
      case ProductStatus.TierOwned:
        return this.i18n.translate('app.pricing.plan_picker.choose_a_plan');
      case ProductStatus.SelfServiceUpgrade:
        return this.i18n.translate('app.pricing.plan_picker.upgrade');
      case ProductStatus.SelfServiceDowngrade:
        return this.i18n.translate('app.pricing.plan_picker.downgrade');
      case ProductStatus.Unavailable:
      case ProductStatus.ManualService:
        return this.i18n.translate('app.common.get_in_touch');
      case ProductStatus.ManualServiceOwned:
        return this.i18n.translate('app.pricing.plan_picker.your_current_plan');
    }
  }
}
